import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_TOOLTIP, ECHART_TOOLBOX, getColorForLabel } from "../../Utilities/echartsTheme";
import { formatNumber } from "../../Utilities/numbers";

const EChartsTreemap = ({ data, valueKey = "value", labelKey = "label" }) => {
  const option = useMemo(() => {
    const items = (data || [])
      .map((d) => ({
        name: d[labelKey] || "Unknown",
        value: Number(d[valueKey]) || 0,
        itemStyle: { color: getColorForLabel(d[labelKey], data.indexOf(d)) },
      }))
      .filter((d) => d.value > 0)
      .sort((a, b) => b.value - a.value);

    const total = items.reduce((s, d) => s + d.value, 0);

    return {
      tooltip: {
        ...ECHART_TOOLTIP,
        formatter: (p) => {
          const pct = total ? ((p.value / total) * 100).toFixed(1) : 0;
          return `<div style="font-weight:600">${p.name}</div>Value: ${formatNumber(p.value)} (${pct}%)`;
        },
      },
      toolbox: ECHART_TOOLBOX,
      series: [
        {
          type: "treemap",
          data: items,
          roam: false,
          nodeClick: "zoomToNode",
          breadcrumb: {
            show: true,
            bottom: 0,
            itemStyle: { color: "#F1F5F9", borderColor: "#E2E8F0" },
          },
          label: {
            show: true,
            formatter: (p) => {
              const pct = total ? ((p.value / total) * 100).toFixed(0) : 0;
              return `{name|${p.name}}\n{val|${formatNumber(p.value)} (${pct}%)}`;
            },
            rich: {
              name: { fontSize: 11, fontWeight: "bold", color: "#fff", lineHeight: 18 },
              val: { fontSize: 10, color: "rgba(255,255,255,0.8)" },
            },
            overflow: "truncate",
          },
          upperLabel: { show: false },
          itemStyle: { borderColor: "#fff", borderWidth: 2, gapWidth: 2 },
          emphasis: {
            itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.2)" },
          },
          levels: [
            {
              itemStyle: { borderColor: "#fff", borderWidth: 2, gapWidth: 2 },
            },
          ],
          animationDuration: 600,
        },
      ],
    };
  }, [data, valueKey, labelKey]);

  if (!data || data.length === 0) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100 text-muted">
        No data available
      </div>
    );
  }

  return <EChart option={option} />;
};

export default EChartsTreemap;
